import { StateSetter, useMemo, useState } from 'react';

import { FullRecruitment, loaders } from 'entities';

import { useSyncRef } from 'hooks/syncRef';
import { useUser } from 'hooks/user';

import { quickContext } from 'utils/react';

import { RecruitmentActions, getRecruitmentActions } from './permissions';
import { RecruitmentTab } from './types';

interface RecruitmentModalContext {
  close: () => void;

  recruitment: FullRecruitment;
  updateRecruitment: StateSetter<FullRecruitment>;
  reload: () => void;

  setTab(tab: RecruitmentTab): void;
  tab: RecruitmentTab;

  permissions: RecruitmentActions;
}

export interface RecruitmentModalContextProps {
  recruitmentId?: string | null;
  onData?: (data: Omit<FullRecruitment, 'requestedBy'>) => void;
  close: () => void;
}

const { withRecruitmentModalContext, useRecruitmentModal } = quickContext(
  'recruitmentModal',
  ({ recruitmentId, onData, close }: RecruitmentModalContextProps) => {
    const user = useUser();

    const [tab, setTab] = useState<RecruitmentTab>('main');

    const { data, overwrite, retry, clear } = loaders.projects.findRecruitment.use({
      blockLoad: !recruitmentId,

      params: {
        recruitmentId: recruitmentId!,
      },

      onDataChange: onData,
    });

    const params = useSyncRef({
      close,
    });

    return {
      data: useMemo(
        () =>
          ({
            tab,
            setTab,

            close: () => {
              params.current.close();

              setTimeout(() => {
                setTab('main');

                clear();
              }, 500);
            },

            recruitment: data!,
            updateRecruitment: overwrite,
            reload: retry,

            permissions: getRecruitmentActions(data, user),
          }) as RecruitmentModalContext,
        [tab, data, overwrite, params, retry, user, clear],
      ),
    };
  },
);

export { withRecruitmentModalContext, useRecruitmentModal };
